//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v10.9.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export enum InspectionFileDataUpdateOption {
    NewAndExistingObjects = "NewAndExistingObjects",
    NewObjects = "NewObjects",
    OnlyGeometries = "OnlyGeometries",
}
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v10.9.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export enum InspectionRelevanceUpdateOption {
    MarkOutdatedOlderThanInterval = "MarkOutdatedOlderThanInterval",
    KeepUnchanged = "KeepUnchanged",
}
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v10.9.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export enum InspectionRelevanceIntervalOption {
    Days7 = "Days7",
    Days14 = "Days14",
    Month1 = "Month1",
    Month3 = "Month3",
}
